import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';
import { type CreateReturnLabelBatchEntry } from '~/types/APIReturnLabels';

/**
 * Service function to create a return label for an outbound shipment
 * @param {CreateReturnLabelParams} { orderID, outboungBatchEntryId? }
 * @returns
 * reference: https://github.com/goshippo/orders/blob/429aa38377a9c7e61c96e0fe0679014db0236ac2/api/batch-entry-facade.yaml#L530
 */
export const createReturnLabelOutbound: CreateReturnLabelBatchEntry = (
  orderId,
  outboundBatchEntryId,
) =>
  ordersAPI.request({
    method: 'POST',
    url: `${WEB_ORDERS_API}/${orderId}/shipments/${outboundBatchEntryId}/return`,
  });
